import React from 'react';
import { FaUnity } from "react-icons/fa";
import { TbCircleDashedPercentage } from "react-icons/tb";

const TokenUtilityTable = () => {
  const data = [
    {
      icon: <TbCircleDashedPercentage className="text-4xl text-yellow-500" />,
      title: 'Discount',
      services: 'Tiered discounts',
      ecosystem: 'Reductions',
      transaction: 'Lower gas fees',
      rwa: '15% discount',
      feature: 'Early access',
      premium: 'Access',
      bg: 'bg-yellow-50',
    },
    {
      icon: <FaUnity className="text-4xl text-orange-500" />,
      title: 'Priority',
      services: 'Premium features',
      ecosystem: 'Staking fees',
      transaction: 'Network fees',
      rwa: 'Early allocation',
      feature: 'Newly launched platform',
      premium: 'Advanced tools',
      bg: 'bg-orange-50',
    },
  ];

  const headers = [
    'Characteristic',
    'Services Discount',
    'Ecosystem Service Fees',
    'Transaction Costs',
    'RWA Token Access',
    'Feature Access',
    'Premium Feature Unlocks',
  ];

  return (
    <div className="w-full px-4 py-6 overflow-x-auto z-40">
      <table className="  min-w-[800px] w-full border-separate border-spacing-2">
        <thead>
          <tr className="text-orange-600 text-base font-bold">
            {headers.map((header, idx) => (
              <th
                key={idx}
                className="bg-gray-300 px-3 py-4 text-center border-2 border-orange-500 rounded-md"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className={`text-sm text-center ${row.bg} font-medium`}
            >
              <td className="px-3 py-2  flex flex-row items-center justify-center gap-1 text-base font-bold text-orange-700 rounded-md'">
                {row.icon}
                {row.title}
              </td>
              <td className="px-3 py-2 border border-white rounded-md">{row.services}</td>
              <td className="px-3 py-2 border border-white rounded-md">{row.ecosystem}</td>
              <td className="px-3 py-2 border border-white rounded-md">{row.transaction}</td>
              <td className="px-3 py-2 border border-white rounded-md">{row.rwa}</td>
              <td className="px-3 py-2 border border-white rounded-md">{row.feature}</td>
              <td className="px-3 py-2 border border-white rounded-md">{row.premium}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TokenUtilityTable;
